

























































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import stepBar from "@/components/searchMember/stepBar.vue";

const searchMemberModule = namespace("searchMember");

@Component({
	components: {
		stepBar,
	},
})
export default class SearchMember extends Vue {
	@searchMemberModule.State("couponDetail") couponDetail!: any;
	@searchMemberModule.State("writeSessionId") writeSessionId!: any;
	@searchMemberModule.State("infoGetWeeks") infoGetWeeks!: any;
	@searchMemberModule.State("infoGetTimes") infoGetTimes!: any;
	@searchMemberModule.State("infoEffectiveDate") infoEffectiveDate!: any;
	// @searchMemberModule.State("entityName") entityName!: any;
	@searchMemberModule.State("memberDetail") memberDetail!: any;
	@searchMemberModule.State("infoEffectiveConditionLimit")
	infoEffectiveConditionLimit!: any;

	writeOffTime: any = "";
	active: number = 2;
	entityName: string = this.$global.tenantName;
	memberUsername: string = this.$global.uName;
	defaultImg: any = require("@/image/default.png");
	created() {
		let memberKeyword = this.$route.query.memberKeyword;
		if (JSON.stringify(this.couponDetail) == "{}") {
			this.$router.push({
				path: `/searchMember/memberDetail`,
				query: { memberKeyword },
			});
		}
	}
	mounted() {
		this.$store.commit("coupon/setcouponSearchStep", 2);
	}
	confirmCancel() {
		(this as any).$dialog
			.confirm({
				title: "确认核销",
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				cancelButtonColor: "#1989fa",
				message: "券码：" + this.couponDetail.couponInstanceQrCode,
			})
			.then((res: any) => {
				if (res == "confirm") {
					this.$store
						.dispatch("searchMember/dispatchCouponDetail", {
							couponInstanceQrCode: this.couponDetail
								.couponInstanceQrCode,
							couponInstanceFlowWriteoffChannel:
								this.couponDetail.writeOffChannel || "商户通",
							operationType: 1,
							writeSessionId: this.writeSessionId,
						})
						.then(({ success, error }) => {
							if (success) {
								this.writeOffTime = success.data.writeOffTime;
								this.active = 3;
								this.$store.commit(
									"coupon/setcouponSearchStep",
									3
								);
								if (
									this.$global.routes.indexOf(
										"/linkedOrder"
									) >= 0
								) {
									(this as any).$dialog
										.confirm({
											title: "核销成功",
											message:
												"是否需要将本优惠券关联到订单?",
											confirmButtonText: '关联订单',
											cancelButtonText: '继续核销',
											cancelButtonColor: '#1989fa'
										})
										.then(() => {
											this.$router.replace(
												"/linkedOrder?qrCode=" +
													this.couponDetail
														.couponInstanceQrCode
											);
										})
										.catch(() => {
											this.$router.go(-1)
										});
								}
							}
						});
				}
			})
			.catch((res: any) => {});
	}
	backIndex() {
		this.$router.push(`/home`);
	}
}
